import React, { useEffect, useState } from 'react'
import './css/LeadInformation.css'
import { MdKeyboardArrowDown } from 'react-icons/md'
import { FaUser } from 'react-icons/fa'
import { CiMenuKebab } from 'react-icons/ci'
import { PiChartBar } from 'react-icons/pi'
import { AiOutlinePlus } from 'react-icons/ai'
import { TfiPencil } from 'react-icons/tfi'
import { PiHandbagSimpleLight } from 'react-icons/pi'
import { BsTelephone } from 'react-icons/bs'
import { CiMail } from 'react-icons/ci'
import { FiLink2 } from 'react-icons/fi'
import { BsGlobe } from 'react-icons/bs'
import { IoCashOutline } from 'react-icons/io5'
import { BiDisc } from 'react-icons/bi'
import { IoMapOutline } from 'react-icons/io5'
import { IoCalendarOutline } from 'react-icons/io5'
import { IoReaderOutline } from 'react-icons/io5'
import { BiTask } from 'react-icons/bi'
import { IoCheckmarkCircleOutline } from 'react-icons/io5'
import { BiTime } from 'react-icons/bi'
import { IoPeopleOutline } from 'react-icons/io5'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'
import AddNewModels from './AddNewModels'
import { RxCross2 } from 'react-icons/rx'
import axios from 'axios'
import api from "../config/backend"
import { Button, Checkbox, FormControlLabel, IconButton, Popover, Tooltip, Typography } from '@mui/material'
import { GoKebabHorizontal } from 'react-icons/go'
import { toast } from "react-toastify"
import UpdateLead from './UpdateLead'
import { BadgeOutlined, BusinessOutlined, HighlightOffOutlined, KeyboardReturn } from '@mui/icons-material'
import Menu from '@mui/material/Menu'
import MoreVert from '@mui/icons-material/MoreVert'
import DOMPurify from 'dompurify'
import { FaLocationDot } from 'react-icons/fa6'
import { LiaClockSolid } from 'react-icons/lia'
import AddActivity from './AddActivity'
import dayjs from 'dayjs'

const LeadInformation = ({ leadData, data, onSaveStage, availableColors, setTriggerRefresh }) => {
    const token = localStorage.getItem("_crm__token")
    const [stagesData, setStagesData] = useState([])
    const [selectedTags, setSelectedTags] = useState([])
    const [clickedTag, setClickedTag] = useState(null)
    const [selectedColor, setSelectedColor] = useState(availableColors[0])
    const [isColorPickerVisible, setIsColorPickerVisible] = useState(false)

    const [openKebabPopover, setOpenKebabPopover] = useState(null)


    const handleToggleColorPicker = () => {
        setIsColorPickerVisible((prevState) => !prevState)
    }

    const handleOpenKebabPopover = (event, tagId) => {
        setOpenKebabPopover(event.currentTarget)
        setSelectedTagId(tagId)
    }

    const handleCloseKebabPopover = () => {
        setOpenKebabPopover(null)
    }


    // const [tagColors, setTagColors] = useState(tagColorsDisplay);
    // console.log(tagColors)



    const handleRemoveTag = (tagToRemove) => {
        setSelectedTags((prevSelectedTags) => prevSelectedTags.filter((tag) => tag !== tagToRemove))
    }

    console.log({ stagesData })

    const [selectedTitle, setSelectedTitle] = useState('')
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const handleDropdownToggle = () => {
        setIsDropdownOpen(prevState => !prevState)
    }
    const [toDoTags, setToDoTags] = useState([])


    const handleTitleSelect = async (stage) => {
        setIsDropdownOpen(false)
        setSelectedTitle(stage.name)

        const { data, status } = await axios.post(`${api}/Leads/update-lead`, { token, hash: leadData.hash, stage: stage.name })

        if (data.success) {
            setTriggerRefresh(prev => prev + 1)
        } else {
            toast.error(data.message)
        }
    }

    const [open, setOpen] = useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    const [openUpdateLead, setOpenUpdateLead] = useState(false)

    const handleClickOpened = () => {
        setOpenUpdateLead(true)
    }

    console.log({ leadData })

    const [isAddingTag, setIsAddingTag] = useState(false)
    const [newTag, setNewTag] = useState('')
    const [tagsData, setTagsData] = useState([])

    const fetchTags = async () => {
        const { data, status } = await axios.post(`${api}/Tags/fetch-tags`, { token })
        console.log("tags:", data.tags)
        if (data.success) {
            setTagsData(data.tags)

        } else {
            console.log(data.message)
        }
    }

    useEffect(() => {
        fetchTags()
    }, [])


    const handleDone = () => {
        handleCloseKebabPopover()
        handleClose2()
    }


    const handleColorSelection = (color, tagId) => {
        const selectedTag = tagsData.find((tag) => tag._id === tagId)

        if (selectedTag) {
            const tagHash = selectedTag.hash
            localStorage.setItem(`tagColor_${tagHash}`, color)

            // setTagColors((prevColors) => ({
            //     ...prevColors,
            //     [tagId]: color,
            // }));
            updateTagColor(tagHash, color, selectedTag.name)
        }
    }


    const updateTagColor = async (tagHash, color, tagName) => {
        try {
            const response = await axios.post(`${api}/Tags/update-tag`, {
                token,
                hash: tagHash,
                tagname: tagName,
                color,
            })

            if (response.data.success) {
                setTriggerRefresh(prev => prev + 1)
            } else {
                toast.error('Failed to update tag color:', response.data.message)
            }
        } catch (error) {
            console.error('Error updating tag color:', error)
        }
    }




    const applyTagColor = (tagName) => {
        // const tagId = tagsData.find((tag) => tag.name === tagName)?._id;
        // const tagColor = tagColors[tagId];
        // return { backgroundColor: tagColor || '' };
    }





    const [createData, setCreateData] = useState([])

    const handleDoneClick = async () => {
        setIsAddingTag(true)
        if (newTag.trim() === '') {
            return
        }

        const { data, status } = await axios.post(`${api}/Tags/create-tag`, { token, tagname: newTag })

        if (data.success) {
            console.log("New tag created:", data.tags)
            // setCreateData(data.tags);
            // setTagsData((prevTagsData) => [...prevTagsData, data.tags]);
            // setSelectedTags((prevSelectedTags) => [...prevSelectedTags, newTag]); // Add the newTag to selectedTags
            // setIsAddingTag(true);
            setNewTag('')
            fetchTags()
        } else {
            console.log("Failed to create tag:", data.message)
        }
    }


    // useEffect(() => {
    //     handleDoneClick()
    // }, [])


    const handleAddTagClick = () => {
        console.log("Add tag button clicked")
        setIsAddingTag(true)
    }





    const fetchStages = async () => {
        const { data, status } = await axios.post(`${api}/Stages/fetch-stages`, { token })

        if (data.success) {
            setStagesData(data.stages)
            console.log(data.stages)
        } else {
            console.log(data.message)
        }
    }

    useEffect(() => {
        fetchStages()
    }, [])



    const [tagDeleteAnchorEl, setTagDeleteAnchorEl] = useState({})

    const [selectedTagId, setSelectedTagId] = useState(null)


    const addTag = async (hash, _id) => {
        console.log({ hash, _id })
        const { data, status } = await axios.post(`${api}/Leads/add-tag`, { token, hash, tagidentifier: _id })
        console.log("tags added", data)
        if (data.success) {
            setTriggerRefresh(prev => prev + 1)

        } else {
            console.log(data.message)
        }
    }

    const removeTag = async (hash, _id) => {
        console.log({ removed: 1, hash, _id })
        const { data, status } = await axios.post(`${api}/Leads/remove-tag`, { token, hash, tagidentifier: _id })

        if (data.success) {
            setTriggerRefresh(prev => prev + 1)

        } else {
            console.log(data.message)
        }
    }

    const handleCheckboxChange = (event, tagName, leadHash, tagidentifier) => {
        console.log({ leadHash, tagidentifier })




        if (event.target.checked) {
            // Checkbox is checked, add the tag to selectedTags
            addTag(leadHash, tagidentifier)

        } else {
            // Checkbox is unchecked, remove the tag from selectedTags
            removeTag(leadHash, tagidentifier)


        }
    }

    const handleToggleTagDelete = (tagId, tagName) => {
        let updatedTags = [...selectedTags]
        setClickedTag(tagId)
        if (updatedTags.includes(tagName)) {
            updatedTags = updatedTags.filter((tag) => tag !== tagName)
        } else {
            updatedTags.push(tagName)
        }
        setSelectedTags(updatedTags)
    }

    const deleteTag = async (hash) => {
        const { data, status } = await axios.post(`${api}/Tags/delete-tag`, { token, hash })
        if (data.success) {
            console.log("Tag deleted successfully:", data.message)
            setTagsData((prevTagsData) => prevTagsData.filter(tag => tag.hash !== hash))
            fetchStages()
        } else {
            console.log("Failed to delete tag:", data.message)
        }
    }
    const [isTagDeletePopoverOpen, setIsTagDeletePopoverOpen] = useState(false)



    const handleOpenTagDeletePopover = (event, tagName, tagId) => {
        setTagDeleteAnchorEl((prevState) => ({
            ...prevState,
            [tagId]: event.currentTarget,
        }))
        setSelectedTagId(tagId)
        setIsColorPickerVisible(prevState => !prevState)


    }


    const openTagDeletePopover = Boolean(tagDeleteAnchorEl[selectedTagId])
    const tagDeletePopoverId = openTagDeletePopover ? `tag-delete-popover-${selectedTagId}` : undefined



    const handleTagPopoverClose = (tagId) => {
        setTagDeleteAnchorEl((prevState) => ({
            ...prevState,
            [tagId]: null,
        }))
    }
    const [checkData, setCheckData] = useState([])


    console.log({ leadData })
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open2 = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose2 = () => {
        setAnchorEl(null)
    }


    const [opened, setOpened] = useState(false)

    const handleClickOpenedactivity = () => {
        setOpened(true)
    }
    console.log({ 'opened': opened })

    const [activities, setActivities] = useState([])
    const markActivityDone = async (activity) => {
        try {
            if (!activity) {
                console.error("Activity is null or undefined")
                return
            }

            const response = await axios.post(`${api}/Leads/activity-completed`, {
                token,
                hash: leadData.hash,
                activityhash: activity.hash
            })

            if (response.data.success) {
                setTriggerRefresh(prev => prev + 1)


            } else {

                console.error("API call was not successful:", response.data.message)
            }
        } catch (error) {
            console.error("Error marking activity as done:", error)

        }
    }

    const address = `${leadData.address ? leadData.address + ", " : ""}${leadData.city ? leadData.city + ", " : ""}${leadData.state ? leadData.state + ", " : ""}${leadData.country ? leadData.country + ", " : ""}${leadData.zipcode ? leadData.zipcode : ""}`

    return (
        <div>
            <AddActivity isDailog={opened} setDailog={setOpened} leadData={leadData} setTriggerRefresh={setTriggerRefresh} />
            {leadData ? (
                <div>

                    <div className='app-modal-leadinformation'>
                        <div className='app-modal-leadinformation__profile'>
                            <div className='app-modal-leadinformation__profile--header'>
                                <div className='app-modal-leadinformation__profile--title'>
                                    <h3>
                                        {leadData.clientname}
                                        <IconButton size="small" onClick={handleClickOpened} > <TfiPencil /></IconButton>
                                        <UpdateLead isPopup={openUpdateLead} setPopup={setOpenUpdateLead} leadData={leadData} setTriggerRefresh={setTriggerRefresh} />
                                    </h3>
                                    <div className='app-modal-leadinformation__profile--addtag'>
                                        <div className='app-component-tag'>
                                            {leadData && leadData.tags.map((tag, index) => {
                                                return (<div
                                                    key={tag}
                                                    className="app-component-tag__chip"
                                                    style={{ backgroundColor: tag.color }}
                                                >
                                                    {tag.name}
                                                </div>)
                                            })}
                                            <Button
                                                size="small"
                                                className='app-btn-text'
                                                id="basic-button"
                                                aria-controls={open2 ? 'basic-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open2 ? 'true' : undefined}
                                                onClick={(e) => { handleClick(e); handleAddTagClick(e) }}>
                                                <AiOutlinePlus /> Add tag
                                            </Button>
                                            <Menu
                                                id="basic-menu"
                                                anchorEl={anchorEl}
                                                open={open2}
                                                onClose={handleClose2}
                                                MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                }}
                                            >
                                                <div className='app-component-addtag'>
                                                    <div className='app-component-addtag__header'>
                                                        <h5>Add Tags</h5>
                                                        <p>Add a new tag and press enter</p>
                                                    </div>
                                                    <div className='app-component-addtag__form'>
                                                        <div className='app-component-addtag__formfield'>
                                                            <input
                                                                type='text'
                                                                placeholder='Add a new tag and press Enter'
                                                                value={newTag}
                                                                onChange={(e) => setNewTag(e.target.value)}
                                                                onKeyDown={(e) => {
                                                                    e.stopPropagation()
                                                                    e.key === 'Enter' && handleDoneClick()
                                                                }}
                                                            />
                                                            <IconButton size='small' onClick={handleDoneClick}>
                                                                <KeyboardReturn />
                                                            </IconButton>
                                                        </div>
                                                        <div className='app-component-addtag__addedtags'>
                                                            <ul>
                                                                {selectedTags.map((tag, index) => (
                                                                    <li key={index}> {tag} <IconButton onClick={() => handleRemoveTag(tag)} size='small'><HighlightOffOutlined /></IconButton></li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className='app-component-addtag__content'>
                                                        <ul className="app-component-addtag--list">
                                                            {tagsData?.map((tag, index) => (
                                                                <li className="app-component-addtag--listitem" key={index}>
                                                                    <FormControlLabel
                                                                        className='app-component-addtag--title'
                                                                        control={<Checkbox size='small' checked={leadData.tags.some(item => item._id === tag._id)} onChange={(e) => handleCheckboxChange(e, tag.name, leadData.hash, tag._id)} />}
                                                                        label={tag?.name}

                                                                    />
                                                                    <div className='app-component-addtag--options'>
                                                                        <Tooltip title="Select tag color">
                                                                            <IconButton
                                                                                size='small'
                                                                                onClick={(e) => handleOpenKebabPopover(e, tag._id)}
                                                                            >
                                                                                <MoreVert />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Tooltip title="Delete Tag">
                                                                            <IconButton
                                                                                size='small'
                                                                                onClick={() => deleteTag(tag.hash)}
                                                                            >
                                                                                <HighlightOffOutlined />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <Popover
                                                                        id={`kebab-popover-${tag._id}`}
                                                                        open={Boolean(openKebabPopover) && selectedTagId === tag._id}
                                                                        anchorEl={openKebabPopover}
                                                                        onClose={handleCloseKebabPopover}
                                                                        anchorOrigin={{
                                                                            vertical: 'bottom',
                                                                            horizontal: 'left',
                                                                        }}
                                                                        PaperProps={{
                                                                            sx: {
                                                                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
                                                                                background: 'white',
                                                                                padding: '16px',
                                                                            },
                                                                        }}
                                                                    >   <span>Select color</span>
                                                                        <div className='app-component-picker'>
                                                                            <ul className='app-component-picker__list'>
                                                                                {availableColors.map((color, index) => (
                                                                                    <li className='app-component-picker__listitem'>
                                                                                        <input className='app-component-picker__listitem--input' type='radio' name="tagcolor" id={`tagcolor${index}`} />
                                                                                        <label
                                                                                            className='app-component-picker__listitem--label'
                                                                                            key={index}
                                                                                            for={`tagcolor${index}`}
                                                                                            value={selectedColor}
                                                                                            style={{ backgroundColor: color }}
                                                                                            onClick={() => handleColorSelection(color, tag._id)}
                                                                                        >
                                                                                        </label>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                        <div className='color-pop-footer'>
                                                                            <Button
                                                                                size='small'
                                                                                onClick={() => {
                                                                                    handleCloseKebabPopover()
                                                                                    applyTagColor(tag._id)
                                                                                }}
                                                                            >
                                                                                Done
                                                                            </Button>
                                                                        </div>
                                                                    </Popover>
                                                                </li>
                                                            ))
                                                            }
                                                        </ul>
                                                    </div>
                                                    <div className='app-component-addtag__footer'>
                                                        <Button size='small' variant='contained' onClick={handleDone}>Done</Button>
                                                    </div>
                                                </div>
                                            </Menu>
                                        </div>
                                    </div>
                                </div>
                                <div className='app-modal-leadinformation__profile--stage'>

                                    <div>
                                        <FormControl>
                                            <Select
                                                labelId="dropdown-title-label"
                                                id="dropdown-title"
                                                className='outline-cont'
                                                open={isDropdownOpen}
                                                onClose={() => setIsDropdownOpen(false)}
                                                onOpen={handleDropdownToggle}
                                                value={selectedTitle ? selectedTitle : leadData.stage}
                                                input={<OutlinedInput />}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: '200px',
                                                        },
                                                    },
                                                }}
                                            >
                                                {stagesData.map((item, index) => (
                                                    <MenuItem
                                                        key={index}
                                                        value={item.name}
                                                        onClick={() => handleTitleSelect(item)}
                                                    >
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className='app-modal-leadinformation__profile--info'>
                                <ul>
                                    {leadData.company && <li>
                                        <BusinessOutlined />
                                        <span>{leadData.company}</span>
                                    </li>}
                                    {leadData.designation && <li>
                                        <BadgeOutlined />
                                        <span>{leadData.designation}</span>
                                    </li>}
                                    {leadData.clientphone && <li>
                                        <BsTelephone />
                                        <span><a href={`tel:${leadData.clientphone}`}>{leadData.clientphone}</a></span>
                                    </li>}
                                    {leadData.clientemail && <li>
                                        <CiMail />
                                        <span><a href={`mailto:${leadData.clientemail}`}>{leadData.clientemail}</a></span>
                                    </li>}
                                    {leadData.website && <li>
                                        <FiLink2 />
                                        <span>{leadData.website}</span>
                                    </li>}
                                    {leadData.dealsize && <li>
                                        <IoCashOutline />
                                        <span>{leadData.dealsize}</span>
                                    </li>}
                                    {address && <li>
                                        <IoMapOutline />
                                        <span>{address.replace(/,\s*$/, "")}</span>
                                    </li>}
                                </ul>
                            </div>
                        </div>
                        <div className='app-modal-leadinformation__notes'>
                            <AddNewModels isDailog={open} setDailog={setOpen} leadData={leadData} setTriggerRefresh={setTriggerRefresh} />
                            <div className='app-modal-leadinformation__notes--header'>
                                <h4>Notes</h4>
                                <Button variant='contained' className='app-btn-contained app-btn-primary' onClick={handleClickOpen}><IoReaderOutline style={{ marginRight: "6px" }} />Add Note</Button>
                            </div>
                            <div className='app-modal-leadinformation__notes--body'>
                                {leadData && leadData.notes && leadData.notes.length > 0 ? (
                                    <div className="app-modal-leadinformation__notes--content">
                                        {leadData.notes.map((note, index) => {
                                            console.log(note)
                                            return (
                                                note && note.trim() !== "" ? (
                                                    <p style={{ display: "flex", alignItems: "center", gap: "10px" }} key={index}>
                                                        ▪ <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note) }}></div>
                                                    </p>
                                                ) : null
                                            )
                                        })}
                                    </div>
                                ) : (
                                    <p>No notes available.</p>
                                )}
                            </div>
                        </div>
                        <div className='app-modal-activities-lead'>

                            <div className='app-modal-leadinformation__notes--header'>
                                <h4>Activities</h4>
                                <div className='add-act-button'>
                                    <Button variant='contained' className='app-btn-contained app-btn-primary' onClick={() => handleClickOpenedactivity()}>
                                        <IoReaderOutline style={{ marginRight: "6px" }} />
                                        Add Activity
                                    </Button>
                                </div>
                            </div>
                            <div className='app-modal-leadinformation-activity'>
                                <div className=''>
                                    {leadData &&
                                        leadData.activities &&
                                        leadData.activities.length > 0 ? (
                                        leadData.activities.map((activity, index) => {
                                            console.log(activity)
                                            // const rawStartDate = activity.startdate;
                                            // const rawEndDate = activity.enddate;


                                            // const formattedStartDate = dayjs(rawStartDate).format('MMM D, YYYY, hh:mm A'); 
                                            // const formattedEndDate = dayjs(rawEndDate).format('hh:mm A'); 

                                            // const formattedDateTime = `${formattedStartDate} - ${formattedEndDate}`;

                                            return (

                                                <div key={activity.hash} className="activity-item">
                                                    <div className="activity-content">
                                                        <h3>{activity.title}</h3>
                                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(activity.description) }}></div>

                                                        <p className='activity-location'><FaLocationDot />{activity.location}</p>
                                                        <p className='activity-location'><LiaClockSolid />
                                                            {activity.isallday ? (

                                                                dayjs(activity.startdate).format('MMM D, YYYY')
                                                            ) : (

                                                                `${dayjs(activity.startdate).format('MMM D, YYYY')},${dayjs(activity.startdate).format('hh:mm A')} - ${dayjs(activity.enddate).format('hh:mm A')}`
                                                            )}</p>
                                                    </div>
                                                    {activity.completed ? (
                                                        <p>Status: Completed</p>
                                                    ) : (
                                                        <button
                                                            className="mark-done-button"
                                                            onClick={() => markActivityDone(activity)}
                                                        >
                                                            Mark as Done
                                                        </button>
                                                    )}
                                                    <div className='bitask-abs' style={{ backgroundColor: activity.color, borderRadius: '60%', padding: '5px' }}>
                                                        <BiTask />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <p>No activities available.</p>
                                    )}
                                </div>
                            </div>
                        </div>



                    </div>
                    {/* <div className='main-div'>

                        <div className="_5xlx">
                        
                            <div className='lead-info-content'>
                                <div className='button-cont'>
                                    
                                    
                                    <button> <span><IoCalendarOutline /></span>New Activity</button>
                                    <button><span><CiMail /></span> Send Email</button>

                                </div>
                           

                                <div className='main-planned'>
                                    <h4>Planned (1)</h4>
                                    <div className='planned-div'>
                                        <div className='planned-content'>
                                            <div className='planned-content-1'>
                                                <h4>Component</h4>
                                                <div className='mark-done'>
                                                    <button><span><IoCheckmarkCircleOutline /></span>Mark as done</button>
                                                    <CiMenuKebab />
                                                </div>
                                            </div>
                                            <div className='planned-content-2'>
                                                <p>Aug 30, 04:15 PM - Aug 31, 04:14 PM</p>
                                                <p> <span><FaUser /></span>Pichikala Pranathi</p>
                                            </div>
                                        </div>


                                        <div className='bi-task'><BiTask /></div>

                                    </div>
                                    <h4>Logs</h4>
                                    <div className='planned-div-logs'>
                                        <div className='planned-content-logs'>
                                            <div className='planned-content-1-logs'>
                                                <p className='first-p'>Component-Calendar Activity Added</p>
                                                <p className='second-p'><span><BiTime /></span>Today</p>
                                            </div>
                                            <div className='planned-content-2-logs' >
                                                <p>Pichikala Pranathi added a task named adaxdad in Calendar</p>
                                                <p> pranathi310800@gmail.com</p>
                                            </div>
                                        </div>




                                        <div className='calend'><IoCalendarOutline /></div>

                                    </div>

                                    <div className='planned-div-logs'>
                                        <div className='planned-content-logs'>
                                            <div className='planned-content-1-logs'>
                                                <p className='first-p'>Lead Updated</p>
                                                <p className='second-p'><span><BiTime /></span>Today</p>
                                            </div>
                                            <div className='planned-content-2-logs' >
                                                <p>Pichikala Pranathi updated this Lead</p>
                                            </div>
                                        </div>


                                        <div className='peopl'><IoPeopleOutline /></div>

                                    </div>
                                </div>
                            </div>


                        </div>

                    </div> */}
                </div>
            ) : undefined}

        </div>
    )
}

export default LeadInformation